import React from "react";
import config from "../data/siteConfig";
import { ArchImage, Ornament, MandalaCorner, BandhaniField } from "./Decor";
import { GiDiamondRing, GiCutDiamond, GiLotus } from "react-icons/gi";
import { FaWhatsapp } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";

// bridal / wedding highlight images (ids verified as "bridal" in gallery.js)
const bridalImgs = [46, 24, 51, 30].map(
  (n) => `/assets/gallery/img-${String(n).padStart(2, "0")}.jpg`
);

const highlights = [
  "Made-to-order bridal sets designed around the bride",
  "Personal design consultation with our Master craftsman",
  "Rajwadi, Kundan-Meena, Antique & Temple styles",
  "Hallmark 916 gold, honestly weighed & fairly priced",
];

export default function WeddingCollection() {
  const c = config.contact;
  const tel = `tel:${c.phonePrimary.replace(/\s/g, "")}`;

  return (
    <section id="wedding" className="relative overflow-hidden bg-coffee-grad py-20 text-cream md:py-28">
      <BandhaniField className="absolute inset-0 text-gold" opacity={0.06} />
      <MandalaCorner className="absolute -left-6 -top-6 h-40 w-40 text-gold/25" />
      <MandalaCorner className="absolute -right-6 bottom-2 h-40 w-40 -scale-x-100 text-gold/25" />

      <div className="container-x relative">
        {/* heading */}
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-gold-light">
            <GiLotus />
            <span className="eyebrow !text-gold-light">The Bridal Atelier</span>
            <GiLotus />
          </span>
          <h2 className="mt-3 font-display text-3xl text-gold-light sm:text-5xl">
            Wedding <span className="font-serif italic text-gold-grad">Collection</span>
          </h2>
          <div className="mt-4 flex justify-center"><Ornament /></div>
          <p className="mx-auto mt-5 max-w-2xl text-cream/85">
            For the most important day, jewellery worthy of the moment — bridal sets crafted to
            order and adorned with the artistry of Kutch.
          </p>
        </div>

        <div className="mt-16 grid items-center gap-12 lg:grid-cols-2">
          {/* bridal image collage */}
          <div className="reveal grid grid-cols-2 gap-4">
            <ArchImage src={bridalImgs[0]} alt="Bridal jewellery set" className="mt-10" imgClass="aspect-[3/4]" />
            <ArchImage src={bridalImgs[1]} alt="Kundan bridal set" imgClass="aspect-[3/4]" />
            <ArchImage src={bridalImgs[2]} alt="Rajwadi bridal necklace" imgClass="aspect-[3/4]" />
            <ArchImage src={bridalImgs[3]} alt="Antique bridal set" className="mt-10" imgClass="aspect-[3/4]" />
          </div>

          {/* Customized Design Master feature */}
          <div className="reveal">
            <div className="inline-flex items-center gap-3 rounded-full border border-gold/50 bg-coffee-950/40 px-4 py-1.5 text-[0.7rem] uppercase tracking-[0.25em] text-gold-light">
              <GiDiamondRing className="text-gold" /> Customized Design Master
            </div>
            <h3 className="mt-5 font-display text-2xl text-gold-light sm:text-3xl">
              Your vision, shaped in gold by our Master craftsman
            </h3>
            <p className="mt-4 text-cream/85">
              Sit with our <strong className="text-gold-light">Customized Design Master</strong> to
              create a bridal set that is truly your own — from the first sketch to the final polish,
              every ornament is handcrafted to your taste, tradition and budget.
            </p>

            <ul className="mt-6 space-y-3">
              {highlights.map((h) => (
                <li key={h} className="flex items-start gap-3 text-cream/90">
                  <GiCutDiamond className="mt-1 shrink-0 text-gold-light" />
                  <span>{h}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-wrap gap-4">
              <a className="btn btn-gold" href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noreferrer">
                <FaWhatsapp /> Book a Design Consultation
              </a>
              <a className="btn btn-ghost" href={tel}>
                <FiPhone /> Call {c.phonePrimaryName}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
